import { t } from 'i18next';

import { TransactionState } from 'support/types';
import { PropertyFilter, PropertyFilterType, SearchPropertyFilter } from 'components/ListTable/types';

export enum RelationshipTransactionFilterKey {
  transactionId = 'transaction_id',
  transactionState = 'transaction_state',
  transactionCreatedBetween = 'transaction_created_between',
}

const searchFilter = (): SearchPropertyFilter => ({
  key: RelationshipTransactionFilterKey.transactionId,
  type: PropertyFilterType.search,
  placeholder: t('connections:relationshipDetails.transactions.filter.searchPlaceholder'),
  label: '',
  value: '',
});

const stateFilter = (): PropertyFilter => ({
  key: RelationshipTransactionFilterKey.transactionState,
  type: PropertyFilterType.dropdown,
  label: t('connections:relationshipDetails.transactions.filter.status.label'),
  value: '',
  dropDownOptions: {
    dropdownValues: [
      { label: t('transactions:list.filter.messageStateOptions.options.inProgress'), value: TransactionState.pending },
      { label: t('transactions:list.filter.messageStateOptions.options.delivered'), value: TransactionState.success },
      { label: t('transactions:list.filter.messageStateOptions.options.dropped'), value: TransactionState.dropped },
      { label: t('transactions:list.filter.messageStateOptions.options.failed'), value: TransactionState.failed },
    ],
  },
});

const dateFilter = (): PropertyFilter => ({
  key: RelationshipTransactionFilterKey.transactionCreatedBetween,
  type: PropertyFilterType.date,
  label: t('connections:relationshipDetails.transactions.filter.date.label'),
  placeholder: t('connections:relationshipDetails.transactions.filter.date.label'),
  value: '',
});

export const getRelationshipTransactionsFilterConfig = (): Array<PropertyFilter | SearchPropertyFilter> => [
  searchFilter(),
  stateFilter(),
  dateFilter(),
];
